import { render } from "./LeadV2.vue?vue&type=template&id=617b42e7&scoped=true"
import script from "./LeadV2.vue?vue&type=script&lang=js"
export * from "./LeadV2.vue?vue&type=script&lang=js"

import "./LeadV2.vue?vue&type=style&index=0&id=617b42e7&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617b42e7"]])

export default __exports__